import React, { Component } from 'react'

export class ApiRedirect extends Component {
  componentWillMount() {
    const token = JSON.parse(localStorage.getItem('accessToken') || 'null')
    window.location.href = `${process.env.REACT_APP_BLINKER_API_URL}/admin/graphiql?access_token=${token.access_token}`
  }

  render() {
    return <section>...Redirecting</section>
  }
}

export default ApiRedirect
